import { useCallback, useEffect } from 'react'

import { useRafState } from './useRafState'

// this will eventually be replaced with a launchdarkly flag
const releaseDarkMode = false

const mql: MediaQueryList = window.matchMedia(
  'screen and (prefers-color-scheme: dark)',
)
export enum ColorScheme {
  dark = 'DARK',
  light = 'LIGHT',
}
const getColorScheme = (matches: boolean) =>
  matches ? ColorScheme.dark : ColorScheme.light

export function useColorScheme(): {
  colorScheme: ColorScheme
  isDarkMode: boolean
} {
  const [colorScheme, setColorScheme] = useRafState(getColorScheme(mql.matches))

  const onChange = useCallback(
    (e: MediaQueryListEvent) => {
      setColorScheme(getColorScheme(e.matches))
    },
    [setColorScheme],
  )

  useEffect(() => {
    mql.addEventListener('change', onChange)

    return () => mql.removeEventListener('change', onChange)
  }, [onChange])

  if (!releaseDarkMode) {
    return {
      colorScheme: ColorScheme.light,
      isDarkMode: false,
    }
  }

  return {
    colorScheme,
    isDarkMode: colorScheme === ColorScheme.dark,
  }
}
